<merchant-payment-method-sidebar (showMerchantPaymentGrid)="getMerchantPayoutAccounts()" [payment]="selectedPaymentMethod" (closePaymentMethodSidebarEmit)="closePaymentMethodSidebar($event)" [showPaymentMethodSidebar]="showPaymentMethodSidebar"></merchant-payment-method-sidebar>

<merchant-payment-details (showMerchantPaymentGrid)="getMerchantPayoutAccounts()" [_showMerchantDetailPaymentSideBar]="showMerchantDetailPaymentSideBar"
[_merchantId]="merchantId"
(changedShowMerchantDetailPaymentSideBarEmit)="changedShowMerchantDetailPaymentSideBarEmit($event)"
*ngIf="showMerchantDetailPaymentSideBar"></merchant-payment-details>

<p-scrollPanel [style]="{height: 'calc(75vh)'}">
        <div class="flex-row">
            <div class="col-6">
                <h4 class="text-color">Payout Management</h4>
                <div class="text-theme-color">
                Manage your payout accounts and assign them to different stores.
                </div>
            </div>
        </div>

        <div *ngIf="loading" style="text-align: center; padding: 30px;">
            <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                            fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
        </div>
        <div class="flex-row">
            <div class="col-3 p-0" *ngFor="let payment of payments">
                <mat-card class="example-card cursor-pointer" appearance="outlined">
                    <mat-card-header>
                        <div class="flex-row w-100">
                            <div class="col-10 p-0">
                                <mat-card-title>
                                    {{ payment.PayServiceName }}
                                </mat-card-title>
                                <mat-card-subtitle>{{ payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet ? 'E-Wallet' : 'Bank'}}</mat-card-subtitle>
                            </div>
                            <div class="col-2 p-0 text-end">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="action menus">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu" class="bg-white px-2">
                                    <button mat-menu-item class="menu-item-danger" (click)="deletePaymentMethod(payment.MerchantId)">
                                    <mat-icon>delete</mat-icon>
                                    <span class="pl-1">Remove</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </div>
                    </mat-card-header>
                    <img mat-card-image class="py-2" (click)="openPaymentMethodSidebar(payment)" src="/XpressApp/assets/images/payment/{{payment.PayServiceName}}.png" alt="{{ payment.PayServiceName }}" height="350">
                    <mat-card-content>
                        <h5><b>{{payment.AccountName}}</b></h5>
                        {{ payment.AccountNumber.length > 4 ? '*'.repeat(payment.AccountNumber.length - 4) + payment.AccountNumber.slice(-4) : payment.AccountNumber}}
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
</p-scrollPanel>